import type { CategoryFields } from 'common/generated/graphQlTypes/CategoryFields';

/** Formats a category for display with its icon and name */
const formatCategory = ({ icon, name }: Pick<CategoryFields, 'icon' | 'name'>) => `${icon} ${name}`;

export default formatCategory;
